export class UserProfile {
  name: string;
  email: string;
  username: string;
  contact: string;
  address: string;
  profile_picture : string;
  }